<template>
    <modal title="Share template" :visible="visible" @close="close">
        <div>
            <p class="c-paragraph">
                Copy this link and share this template with your friends
            </p>

            <div class="modal__input">
                <input class="c-input u-margin-vertical-xs copy-js"
                       type="text"
                       readonly
                       v-model="absoluteUrl" />

                <button class="c-button c-button--secondary"
                        v-clipboard:success="copy"
                        v-clipboard:copy="absoluteUrl">
                    {{ isCopied ? "Copied!" : "Copy" }}
                </button>
            </div>
        </div>
    </modal>
</template>

<script>
    import modal from "../components/modal.vue";

    export default {
        props: {
            visible: { type: Boolean },
            url: { type: String }
        },
        data: function () {
            return {
                isCopied: false
            };
        },
        computed: {
            absoluteUrl: function () {
                const absoluteUrl = new URL(this.url, window.location.href);
                return absoluteUrl.href;
            }
        },
        methods: {
            copy: function () {
                this.isCopied = true;
            },
            close: function () {
                this.isCopied = false;
                this.visible = false;
                this.$emit("close");
                this.$emit("update:visible", this.visible);
            }
        },
        components: {
            modal
        }
    };
</script>